import { Location } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
	selector: "app-not-found",
	templateUrl: "./not-found.component.html",
	styleUrls: ["./not-found.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NotFoundComponent implements OnInit {
	constructor(private location: Location) {}

	ngOnInit(): void {
		setTimeout(() => {
			this.location.back();
		}, 2000);
	}
}
